import "./bootstrap";
import Alpine from "alpinejs";
import Litepicker from "litepicker";
import moment from "moment";
import Chart from "chart.js/auto";
window.Alpine = Alpine;
window.Litepicker = Litepicker;
window.moment = moment;
window.Chart = Chart;
Alpine.start();
